import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';
import { Typography } from '../style/Typography';
import GlootIcon from '../svg/gloot-logo-white.svg';

const StyledHeader = styled.header`
  background: ${props => props.theme.backgrounds.tertiaryDark};
  color: ${props => props.theme.colors.copy};
  height: 80px;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;

  a {
    z-index: 10;
    color: ${props => props.theme.colors.copy};
    text-decoration: none;
  }

  h3 {
    margin-left: 12px;
  }

  @media only screen and (max-width: ${props =>
      props.theme.breakpoints.medium}) {
    .header-text {
      display: none;
    }
  }
`;

const Header = () => (
  <StyledHeader>
    <Link to="/" aria-label="Home">
      <GlootIcon style={{ height: '38px' }} />
    </Link>
    <Link to="/" className="header-text">
      <Typography variant="h3">G-Loot Patch Notes</Typography>
    </Link>
  </StyledHeader>
);

export default Header;
